import(/* webpackMode: "eager" */ "/home/interim/frontend/app/resources/page.tsx");
